import ProductDescription from './ProductDescription'

const WheatPastaProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '009',
  IsBroadband: true,
  WholeWheatFlour: false,
  PastaShape: '',
  Size: '',
}

export default WheatPastaProduct
